import React, { useContext } from 'react';
import { bool, func } from 'prop-types';
import * as R from 'ramda';

// Components
import { Box } from '@mui/material';
import Buttons from '../../components/Buttons';
import LocationCheckboxList from '../../components/LocationCheckboxList.connector';
import SummaryDrawer from '../../components/SummaryDrawer';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const PrimaryStep3 = ({ loading, prev, next }) => {
  const {
    data: { locations = [], products = [], inventoryOwners = [] },
    setData,
  } = useContext(SequencingWizardContext);
  const continueDisabled = R.isEmpty(locations);
  const handleChange = R.o(setData, R.assoc('locations'));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 203px
          // prevents progress bar from looking off
          height: 'calc(100% - 203px)',
          mb: '46px',
          overflowY: 'auto',
        }}
      >
        <Box flexGrow={1}>
          <LocationCheckboxList
            onChange={handleChange}
            products={products}
            title={`Select one or more locations where ${inventoryOwners[0]?.companyCustomerIdName} ${inventoryOwners[0]?.nameShort} products are available`}
          />
        </Box>
        <SummaryDrawer displayProducts inventoryOwnerSubtitle="Primary Inventory Owner" />
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={loading}
        rightLabel="Continue"
      />
    </>
  );
};

PrimaryStep3.propTypes = {
  loading: bool.isRequired,
  next: func.isRequired,
  prev: func.isRequired,
};

export default PrimaryStep3;
